<template>
  <div class="top" :style="{ 'background-image': `url('${bgUrl}')` }"></div>
</template>
<script>
import Common from "./Common";

export default {
  name: "TopImg",
  mixins: [Common],
  data() {
    return {
      bgUrl: ""
    };
  },
  mounted() {
    this.getConfig();
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.top {
  width: 100%;
  .mixin_com(height, 490);

  background: url("~@/assets/images/news/top.jpg") no-repeat center top / cover;
}
</style>
